// import { toast } from "sonner";

export function getFromStage({
  stagePipeline,
  herirarchy,
  isLastOne,
  id,
  isName,
}: any) {
  if (!stagePipeline?.length) {
    // toast.error("Please give the pipeline to the fucniton");
    return;
  }

  if (id) {
    const pipeline = stagePipeline.find((val: any) => val.id == id);
    // Null-safe: a stored stageId can reference a stage that's since been
    // deleted/renamed (a stale role access_config after a pipeline change),
    // so `find` returns undefined. Return undefined instead of throwing
    // "Cannot read properties of undefined (reading 'name')".
    if (isName) return pipeline?.name;
    return pipeline;
  }

  const length = stagePipeline.length;

  if (isLastOne) {
    if (isName) return stagePipeline[length - 1].name;
    return stagePipeline[length - 1];
  }

  if (herirarchy) {
    const pipeline = stagePipeline.find(
      (val: any) => val.hierarchy == herirarchy
    );

    if (isName) return pipeline?.name;
    return pipeline;
  }
  throw new Error("Something Went wrong");
}
